import React from 'react';
import PropTypes from 'prop-types';
import BasicFormField from '../../../../common/formFields/basicFormField';
import InstagramAuth from '../../../../common/InstagramAuth';
import AddressForm from '../../../../common/addressForm';
import SaveButton from '../../../../common/buttons/saveButton';
import CancelButtonLink from '../../../../common/buttons/cancelButtonLink';
import Input from '../../../../common/input';
import LanguageMultiSelectField from '../../../../common/LanguageMultiSelect';
import SelectField from '../../../../common/ModernSelect';
import { t } from '../../../../../modules/infra/i18n';

const BrandSettings = ({
  initialValues,
  brandCountry,
  handleSubmit,
  busy,
  cancelHref,
  supportedLanguages,
  showMetaPixelManagement,
  showAnalyticsManagement,
  conversionTracking,
}) => (
  <form className="c-inner-wrapper u-max-width-710 u-mt u-pt" onSubmit={handleSubmit}>
    <InstagramAuth
      owner="brand"
      id={initialValues.id}
      wrapperClass="layout__item u-1/2-medium-and-up u-float-left u-pl0"
    />
    <BasicFormField
      placeholder={t('settings:brand_settings.instagram_label')}
      label={t('settings:brand_settings.instagram_label')}
      name="instagram"
      disabled
    />
    <AddressForm country={brandCountry} wrapperClassName="" headerClassName="u-pl0" />
    <div className="u-mt">
      <div className="c-label-new">{t('settings:brand_settings.email_label')}</div>
      <Input
        className="c-input"
        name="email"
        type="email"
        placeholder={t('settings:brand_settings.email_placeholder')}
      />
    </div>
    <div className="c-separator u-mb u-mt+" />
    <div className="c-heading u-mb-">{t('settings:brand_settings.language_settings')}</div>
    <section>
      <div className="layout">
        <LanguageMultiSelectField
          label={t('settings:brand_settings.supported_languages')}
          name="settings.supportedLanguages"
        />
        <SelectField
          label={t('settings:brand_settings.default_language')}
          name="settings.defaultLanguage"
          options={supportedLanguages}
        />
      </div>
    </section>

    {showAnalyticsManagement && conversionTracking && (
      <>
        <div className="c-separator u-mb u-mt+" />
        <div className="c-heading">{t('settings:brand_settings.conversion_tracking')}</div>

        <div className="u-mt-">
          <p className="c-heading u-fontsize-normal u-mb--">{t('settings:brand_settings.google_analytics')}</p>
          <p className="u-fontsize-small u-linenormal u-font-color-grey">
            {t('settings:brand_settings.google_analytics_description')}{' '}
            <a
              className="c-link-blue u-fontsize-small"
              href="https://getsquire.my.site.com/help/s/article/Setting-up-Google-Ad-conversion-tracking-in-Commander"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('settings:brand_settings.find_out_how')}
            </a>
          </p>

          <div className="c-label-new u-mt-">{t('settings:brand_settings.ga4_measurement_id')}</div>
          <Input
            className="c-input"
            name="settings.gaMeasurementId"
            type="text"
            placeholder={t('settings:brand_settings.ga4_placeholder')}
          />
        </div>

        {showMetaPixelManagement && conversionTracking && (
          <div className="u-mt">
            <p className="c-heading u-fontsize-normal u-mb--">{t('settings:brand_settings.meta')}</p>
            <p className="u-fontsize-small u-linenormal u-font-color-grey">
              {t('settings:brand_settings.meta_description')}{' '}
              <a
                className="c-link-blue u-fontsize-small"
                href="https://getsquire.my.site.com/help/s/article/Setting-up-Meta-conversion-tracking-in-Commander"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('settings:brand_settings.find_out_how')}
              </a>
            </p>
            <div className="c-label-new u-mt-">{t('settings:brand_settings.meta_pixel_id')}</div>
            <Input
              className="c-input"
              name="settings.metaPixelId"
              type="text"
              placeholder={t('settings:brand_settings.meta_pixel_placeholder')}
            />
          </div>
        )}
      </>
    )}
    <div className="c-separator u-mb u-mt+" />

    <div className="u-text-right">
      <CancelButtonLink link={cancelHref} content={t('settings:brand_settings.cancel_button')} />
      <SaveButton content={t('settings:brand_settings.save_button')} disabled={busy} />
    </div>
  </form>
);

BrandSettings.propTypes = {
  initialValues: PropTypes.object.isRequired,
  brandCountry: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  busy: PropTypes.bool.isRequired,
  cancelHref: PropTypes.string.isRequired,
  supportedLanguages: PropTypes.array.isRequired,
  showMetaPixelManagement: PropTypes.bool.isRequired,
  showAnalyticsManagement: PropTypes.bool.isRequired,
  conversionTracking: PropTypes.bool.isRequired,
};

BrandSettings.defaultProps = {
  brandCountry: null,
};

export default BrandSettings;
